/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1PersonIdAddressesAddresspersonidMutationResponse,
  DeleteApiV1PersonIdAddressesAddresspersonidPathParams,
  DeleteApiV1PersonIdAddressesAddresspersonid401,
  DeleteApiV1PersonIdAddressesAddresspersonid404,
  DeleteApiV1PersonIdAddressesAddresspersonid500,
} from "../../types/personRegisterController/DeleteApiV1PersonIdAddressesAddresspersonid.ts";

function getDeleteApiV1PersonIdAddressesAddresspersonidUrl(
  id: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["id"],
  addressPersonId: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"],
) {
  const res = {
    method: "DELETE",
    url: `/api/v1/person/${id}/addresses/${addressPersonId}` as const,
  };
  return res;
}

/**
 * @description Remove um endereço vinculado à pessoa. **(Requer Authorization para autenticação)**
 * @summary Excluir endereço da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/addresses/:addressPersonId}
 */
export async function deleteApiV1PersonIdAddressesAddresspersonid(
  id: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["id"],
  addressPersonId: DeleteApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1PersonIdAddressesAddresspersonidMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1PersonIdAddressesAddresspersonid401
      | DeleteApiV1PersonIdAddressesAddresspersonid404
      | DeleteApiV1PersonIdAddressesAddresspersonid500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1PersonIdAddressesAddresspersonidUrl(
      id,
      addressPersonId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
